import { render, staticRenderFns } from "./AssignRoleModal.vue?vue&type=template&id=9898014c&scoped=true"
import script from "./AssignRoleModal.vue?vue&type=script&lang=js"
export * from "./AssignRoleModal.vue?vue&type=script&lang=js"
import style0 from "./AssignRoleModal.vue?vue&type=style&index=0&id=9898014c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9898014c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9898014c')) {
      api.createRecord('9898014c', component.options)
    } else {
      api.reload('9898014c', component.options)
    }
    module.hot.accept("./AssignRoleModal.vue?vue&type=template&id=9898014c&scoped=true", function () {
      api.rerender('9898014c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/Modal/AssignRoleModal.vue"
export default component.exports